import { useMemo } from 'react';
import { STEP_TRANSLATIONS } from '../constants';

interface UseLoadingStepsProps {
  currentStep: number;
}

export function useLoadingSteps({ currentStep }: UseLoadingStepsProps) {
  const getStepText = useMemo(() => {
    return (step: number): string => {
      return STEP_TRANSLATIONS[step] || 'LOADING';
    };
  }, []);

  const currentStepText = useMemo(() => {
    return getStepText(currentStep);
  }, [currentStep, getStepText]);

  return {
    getStepText,
    currentStepText,
  };
}
